import { createContext, useContext, useState } from "react";

const translations = {
  fi: {
    nav: {
      services: "Palvelut",
      work: "Työt",
      manifesto: "Manifesti",
      studio: "Studio",
      contact: "Yhteys",
      cta: "Aloita projekti",
    },
    hero: {
      eyebrow: "Noste Creative Studio — Oulu",
      lines: ["VERKKOSIVUJA", "& BRÄNDEJÄ", "KASVUUN."],
      sub: "Luomme yrityksille moderneja nettisivuja ja brändejä — kohti tuottavampaa ja näyttävämpää tulevaisuutta.",
      ctaPrimary: "Aloita projekti",
      ctaSecondary: "Katso töitämme",
      stats: [
        { value: "40+", label: "Projektia" },
        { value: "98%", label: "Tyytyväisyys" },
        { value: "3×", label: "Awwwards" },
      ],
      scroll: "Selaa alas",
    },
    marquee: "NOSTE CREATIVE STUDIO • BUILT FOR GROWTH • VERKKOSIVUT • BRÄNDÄYS • DIGITAALINEN KASVU • OULU • 2026 • ",
    services: {
      eyebrow: "Palvelut",
      title: "Mitä me teemme",
      items: [
        {
          id: "web-design",
          num: "01",
          title: "Verkkosivut & Digitaaliset Alustat",
          desc: "Räätälöidyt, salamannopeat ja konvertoivat nettisivut moderneilla teknologioilla.",
          tags: ["React / Next", "Tailwind CSS", "High Performance", "CMS"],
        },
        {
          id: "branding",
          num: "02",
          title: "Brändi-identiteetti & Visuaalisuus",
          desc: "Erottuva ilme, typografia ja tarinankerronta, joka herättää luottamusta ja kunnioitusta.",
          tags: ["Logo & Guidelines", "Visual Strategy", "Typography", "Motion"],
        },
        {
          id: "digital-growth",
          num: "03",
          title: "Digitaalinen Kasvu & Optimointi",
          desc: "Käyttäjäkokemuksen hiominen, konversio-optimointi ja tulospohjainen suunnittelu.",
          tags: ["CRO", "Analytics", "UX Research", "Funnel Design"],
        },
      ],
    },
    work: {
      eyebrow: "Referenssit",
      title: "Valikoituja töitä",
      viewCase: "Katso case",
      close: "Sulje",
      resultLabel: "Tulos",
      items: [
        {
          id: "lumia-nordic",
          client: "Lumia Health & Bio",
          category: "Web & Branding",
          year: "2026",
          image: "https://images.unsplash.com/photo-1702479744120-98fffb81bf6d?crop=entropy&cs=srgb&fm=jpg&q=85",
          summary: "Pohjoismaisen bioteknologiayrityksen digitaalinen ilme ja verkkosivusto.",
          result: "+180% liidien konversio",
        },
        {
          id: "valoa-architects",
          client: "Valoa Spatial Studio",
          category: "Brand & Digital Showcase",
          year: "2025",
          image: "https://images.unsplash.com/photo-1702479743967-3dcccd4a671d?crop=entropy&cs=srgb&fm=jpg&q=85",
          summary: "Arkkitehtitoimiston minimalistinen portfolionäyttely ja identiteetti.",
          result: "Awwwards Site of the Day",
        },
        {
          id: "korpi-sound",
          client: "Korpi Audio Systems",
          category: "E-Commerce & Branding",
          year: "2025",
          image: "https://images.pexels.com/photos/8489951/pexels-photo-8489951.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
          summary: "Hifi-äänentoistolaitteiden verkkokauppaelämys ja pakkaussuunnittelu.",
          result: "1,2 M€ avajaiskuun liikevaihto",
        },
        {
          id: "aatos-capital",
          client: "Aatos Venture Group",
          category: "Fintech Platform",
          year: "2026",
          image: "https://images.unsplash.com/photo-1697292866722-13f228a35326?crop=entropy&cs=srgb&fm=jpg&q=85",
          summary: "Sijoitusrahaston moderni web-sovellus ja dashboard-integraatio.",
          result: "4× käyttäjäretentio",
        },
      ],
    },
    manifesto: {
      eyebrow: "Manifesti",
      title: "Meidän manifestimme",
      chapters: [
        {
          num: "01",
          heading: "Ei bulkkia, ei teemoja.",
          body: "Jokainen pikseli ja rivi koodia rakennetaan mittatilaustyönä asiakkaamme liiketoiminnan tarpeisiin.",
        },
        {
          num: "02",
          heading: "Design joka kasvattaa.",
          body: "Kauneus ilman tuloksia on taidetta. Me teemme suunnittelua, joka tuo mitattavaa kasvua.",
        },
        {
          num: "03",
          heading: "Pohjoismainen tarkkuus.",
          body: "Yhdistämme skandinaavisen selkeyden, rohkean typografian ja maailmanluokan suorituskyvyn.",
        },
      ],
    },
    studio: {
      eyebrow: "Studio",
      title: "Tiimi kasvun takana",
      body: "Pieni tiimi, suuri näyttö. Yhdistämme strategian, designin ja teknologian saman katon alle Oulussa.",
      members: [
        { name: "Pyry Selander", role: "Toimitusjohtaja (CEO)", image: null },
        { name: "Vili Lehto", role: "Operatiivinen johtaja (COO)", image: null },
      ],
    },
    contact: {
      eyebrow: "Yhteys",
      title: "Aloitetaan kasvu.",
      sub: "Kerro projektistasi — palaamme asiaan 24 tunnin kuluessa.",
      name: "Nimi",
      namePlaceholder: "Etunimi Sukunimi",
      email: "Sähköposti",
      emailPlaceholder: "nimi@yritys.fi",
      company: "Yritys",
      companyPlaceholder: "Yritys Oy",
      budget: "Budjetti",
      budgets: ["< 5 000 €", "5 000 – 15 000 €", "15 000 – 50 000 €", "50 000 € +"],
      servicesLabel: "Mitä tarvitset?",
      services: [
        { id: "web", label: "Verkkosivut" },
        { id: "branding", label: "Brändäys" },
        { id: "growth", label: "Digikasvu" },
        { id: "other", label: "Muu" },
      ],
      message: "Viesti",
      messagePlaceholder: "Kerro lyhyesti tavoitteistasi…",
      submit: "Lähetä viesti",
      sending: "Lähetetään…",
      success: "Kiitos yhteydenotostasi! Vastaamme 24 tunnin kuluessa.",
      error: "Lähetys epäonnistui. Yritä uudelleen.",
      emailUs: "hello@noste.fi",
      phone: "+358 40 123 4567",
      address: "Oulu, Suomi",
    },
    footer: {
      tagline: "Built for growth.",
      rights: "© 2026 Noste Creative Studio. Kaikki oikeudet pidätetään.",
      admin: "Admin",
      navigate: "Navigaatio",
      contactTitle: "Yhteystiedot",
    },
  },
  en: {
    nav: {
      services: "Services",
      work: "Work",
      manifesto: "Manifesto",
      studio: "Studio",
      contact: "Contact",
      cta: "Start Project",
    },
    hero: {
      eyebrow: "Noste Creative Studio — Oulu",
      lines: ["WEBSITES &", "BRANDS BUILT", "FOR GROWTH."],
      sub: "We build modern websites and brands for ambitious companies — towards a more productive, more striking future.",
      ctaPrimary: "Start a project",
      ctaSecondary: "See our work",
      stats: [
        { value: "40+", label: "Projects shipped" },
        { value: "98%", label: "Client satisfaction" },
        { value: "3×", label: "Awwwards nominations" },
      ],
      scroll: "Scroll down",
    },
    marquee: "NOSTE CREATIVE STUDIO • BUILT FOR GROWTH • WEBSITES • BRANDING • DIGITAL GROWTH • OULU • 2026 • ",
    services: {
      eyebrow: "Services",
      title: "What we do",
      items: [
        {
          id: "web-design",
          num: "01",
          title: "Web Architecture & Digital Experiences",
          desc: "Custom, lightning-fast, and high-converting websites built with cutting-edge tech.",
          tags: ["React / Next", "Tailwind CSS", "High Performance", "CMS"],
        },
        {
          id: "branding",
          num: "02",
          title: "Brand Identity & Art Direction",
          desc: "Distinctive visual systems, typography, and storytelling designed to command authority.",
          tags: ["Logo & Guidelines", "Visual Strategy", "Typography", "Motion"],
        },
        {
          id: "digital-growth",
          num: "03",
          title: "Digital Growth & Conversion Optimization",
          desc: "Conversion rate optimization, frictionless UX flows, and metric-driven UI design.",
          tags: ["CRO", "Analytics", "UX Research", "Funnel Design"],
        },
      ],
    },
    work: {
      eyebrow: "Selected Work",
      title: "Case studies",
      viewCase: "View case",
      close: "Close",
      resultLabel: "Result",
      items: [
        {
          id: "lumia-nordic",
          client: "Lumia Health & Bio",
          category: "Web & Branding",
          year: "2026",
          image: "https://images.unsplash.com/photo-1702479744120-98fffb81bf6d?crop=entropy&cs=srgb&fm=jpg&q=85",
          summary: "Digital presence and high-touch web platform for a Nordic biotech leader.",
          result: "+180% lead conversion rate",
        },
        {
          id: "valoa-architects",
          client: "Valoa Spatial Studio",
          category: "Brand & Digital Showcase",
          year: "2025",
          image: "https://images.unsplash.com/photo-1702479743967-3dcccd4a671d?crop=entropy&cs=srgb&fm=jpg&q=85",
          summary: "Minimalist spatial portfolio showcase and dark editorial branding system.",
          result: "Awwwards Site of the Day",
        },
        {
          id: "korpi-sound",
          client: "Korpi Audio Systems",
          category: "E-Commerce & Branding",
          year: "2025",
          image: "https://images.pexels.com/photos/8489951/pexels-photo-8489951.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
          summary: "Luxury acoustic hardware direct-to-consumer store and tactile packaging.",
          result: "€1.2M launch month revenue",
        },
        {
          id: "aatos-capital",
          client: "Aatos Venture Group",
          category: "Fintech Platform",
          year: "2026",
          image: "https://images.unsplash.com/photo-1697292866722-13f228a35326?crop=entropy&cs=srgb&fm=jpg&q=85",
          summary: "Modern venture capital portal with real-time portfolio analytics.",
          result: "4x user retention speed",
        },
      ],
    },
    manifesto: {
      eyebrow: "Manifesto",
      title: "Our manifesto",
      chapters: [
        {
          num: "01",
          heading: "Zero template slop.",
          body: "Every pixel and code line is custom crafted from zero to elevate your enterprise distinction.",
        },
        {
          num: "02",
          heading: "Design that drives revenue.",
          body: "Beauty without conversion is just static art. We build growth engines disguised as digital fine art.",
        },
        {
          num: "03",
          heading: "Nordic precision, global punch.",
          body: "Merging clean Finnish clarity with aggressive typography and ultra-fast web engineering.",
        },
      ],
    },
    studio: {
      eyebrow: "Studio",
      title: "The people behind Noste",
      body: "A small team with outsized output. Strategy, design and technology under one roof in Oulu.",
      members: [
        { name: "Pyry Selander", role: "CEO", image: null },
        { name: "Vili Lehto", role: "COO", image: null },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's grow.",
      sub: "Tell us about your project — we reply within 24 hours.",
      name: "Name",
      namePlaceholder: "First Last",
      email: "Email",
      emailPlaceholder: "name@company.com",
      company: "Company",
      companyPlaceholder: "Company Ltd",
      budget: "Budget",
      budgets: ["< €5,000", "€5,000 – €15,000", "€15,000 – €50,000", "€50,000 +"],
      servicesLabel: "What do you need?",
      services: [
        { id: "web", label: "Websites" },
        { id: "branding", label: "Branding" },
        { id: "growth", label: "Digital growth" },
        { id: "other", label: "Other" },
      ],
      message: "Message",
      messagePlaceholder: "Briefly describe your goals…",
      submit: "Send message",
      sending: "Sending…",
      success: "Thank you! We will get back to you within 24 hours.",
      error: "Sending failed. Please try again.",
      emailUs: "hello@noste.fi",
      phone: "+358 40 123 4567",
      address: "Oulu, Finland",
    },
    footer: {
      tagline: "Built for growth.",
      rights: "© 2026 Noste Creative Studio. All rights reserved.",
      admin: "Admin",
      navigate: "Navigate",
      contactTitle: "Contact",
    },
  },
};

const LanguageContext = createContext(null);

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("fi");
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
